module.exports = __webpack_public_path__ + "static/Andrew-Martin.4360e99f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Andrew-Martin.jpg
// module id = 49
// module chunks = 120424840372386 232439770362922 253875486455892